import { render } from "./SkillModal.vue?vue&type=template&id=0b753d0e&scoped=true"
import script from "./SkillModal.vue?vue&type=script&lang=js"
export * from "./SkillModal.vue?vue&type=script&lang=js"

import "./SkillModal.vue?vue&type=style&index=0&id=0b753d0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b753d0e"]])

export default __exports__